import React, { useLayoutEffect, useState } from "react";
import DynamicForm from "components/DynamicForm";
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Container, Row } from "reactstrap";
import form from 'formConfigs/addPrice';
import Heading from "components/Heading";
import { errorHandler } from "utils/Api";
import { showAlert } from "utils/Alert";
import { getPrice, savePrice } from "api/PriceApi";
import { getTypeCounterByName } from "api/TypeCounterApi";
import { sequenceGenerator } from "utils/Form";
import { SEQUENCETYPES } from "utils/Constants";

const AddPrice = props => {
  let navigate = useNavigate();
  let { id: priceId } = useParams();
  const [priceData, setPriceData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    if (priceId) {
      setIsLoading(true);
      loadPriceData(priceId);
    } else {
      generatePriceId();
    }
  }, [priceId]);

  const generatePriceId = async () => {
    const counter = await getTypeCounterByName(SEQUENCETYPES.COST);
    const priceNumber = sequenceGenerator(SEQUENCETYPES.COST, counter);
    setPriceData({
      ...priceData,
      secuencia: priceNumber
    });
  }

  const loadPriceData = (priceId) => {
    getPrice(priceId).then((priceObject) => {
      setPriceData(priceObject);
    }).catch((e) => console.log("fetch price data error", e))
      .finally(() => { setIsLoading(false) });
  }

  const addPrice = (data) => {
    setIsLoading(true);
    
    savePrice(data).then(async (r) => {
      const priceAlert = (data && data.id) ? "" : `. El numero de paquete es ${r.secuencia} `;
      showAlert("success",
        `Paquete ${((data && data.id) ? "actualizado" : "creado")} exitosamente${priceAlert}`
      );
      navigate("/admin/prices");
    }).catch(e => {
      errorHandler(e);
      showAlert("danger", "No fue posible guardar la informacion del paquete");
    }).finally(() => { setIsLoading(false) });

  };

  return (
    <>
      <Heading yellowBg={true} headingLevel="h2" className="pt-4 pb-4" label="Informacion de Precio" sticky bordered >
        <Col sm={2}>
          <Row>
            <Col>
              <Button color="danger" onClick={(e) => { navigate("/admin/prices") }}> Cerrar</Button>
            </Col>
            <Col >
              <Button className="float-end" form="addPrice" type="submit" color="success"> Guardar</Button>
            </Col>
          </Row>
        </Col>
      </Heading>
      <Container>
        <DynamicForm
          id="addPrice"
          externalFormState={priceData}
          formConfig={form}
          isLoading={isLoading}
          onSubmit={addPrice} >
        </DynamicForm>
      </Container>
    </>
  );
}

export default AddPrice;
